/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';
import { hash } from '@linc-technologies/linced-common/utils/promise';

import GoalState from '@linc-technologies/linced-common/enums/goal-state';

export default class SubjectRoute extends Route {
  // Services
  @service
  store;

  model(params) {
    let store = this.store;
    let group = this.modelFor('group');

    return hash({
      group,
      subject: store.findRecord('goals/subject', params.subject_id),
      categories: store.query('goals/category', {
        subjectId: params.subject_id,
      }),
      subcategories: store.query('goals/subcategory', {
        subjectId: params.subject_id,
      }),
      states: store.query('goals/state', {
        subjectId: params.subject_id,
        groupId: group.id,
        current: true,
        awarded: GoalState.DEVELOPING,
        include: 'goals',
      }),
    });
  }
}
